import { AUTH_HEADERS } from '@libs/core';
import type { LoyaltyOffersResponse } from '@libs/common-types';
import { client } from '../../client';
import { getAccessToken } from '../../utils';
import { CWEA_ENDPOINTS } from '../../constants';

export async function getOffers() {
    const token = getAccessToken();

    if (!token) {
        return null;
    }

    const url = CWEA_ENDPOINTS.loyalty.getOffers;
    return await client.cwea<LoyaltyOffersResponse>(url, {
        headers: {
            [AUTH_HEADERS.AUTHORIZATION]: `Bearer ${token}`,
        },
    });
}
